import React from 'react';

const EstadoContext = React.createContext();

export default EstadoContext;
